import { initiateVue } from '../javascripts/helpers/vue-helper'

import FormFeedback from '../javascripts/vue-components/form/FormFeedback'
import Modal from '../javascripts/vue-components/modal/Modal'
import Toggle from '../javascripts/vue-components/toggle/Toggle'
import VMapInteractive from '../javascripts/vue-components/map/VMapInteractive'

import store from '../javascripts/store/store-map.js'

initiateVue({ 
  FormFeedback,
  Modal,
  Toggle,
  VMapInteractive 
}, store)
